import { Component, OnInit, inject } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProductService, ProductPickerItem } from '../../../../_services/product.service';
import { StockScrapService } from '../../../../_services/stock-scrap.service';
import { AlertService } from '../../../../_services/alert.service';
import { ProductPickerComponent } from '../../../../../Shared/_components/product-picker/product-picker.component';

@Component({
    selector: 'app-create-stock-scrap',
    imports: [
    FormsModule,
    MatDialogContent,
    MatIconModule,
    MatTooltipModule,
    ProductPickerComponent
],
    templateUrl: './create-stock-scrap.component.html',
    styleUrl: './create-stock-scrap.component.css'
})
export class CreateStockScrapComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<CreateStockScrapComponent>);

  products: ProductPickerItem[] = [];
  productSearchTerm = '';
  selectedProduct: ProductPickerItem | null = null;

  quantity: number | null = null;
  // Kettering rarely holds stock in practice, so default to where the write-off usually is.
  warehouse = 'Markstey';
  reason = 'DAMAGED';
  notes = '';
  submitting = false;

  readonly reasonOptions = [
    { value: 'DAMAGED', label: 'Damaged', icon: 'broken_image' },
    { value: 'LOST', label: 'Lost', icon: 'help_outline' },
    { value: 'EXPIRED', label: 'Expired', icon: 'event_busy' },
    { value: 'QUALITY_REJECT', label: 'Quality reject', icon: 'thumb_down' },
    { value: 'OTHER', label: 'Other', icon: 'tune' },
  ];
  warehouseOptions = ['Kettering', 'Markstey'];

  constructor(
    private productService: ProductService,
    private stockScrapService: StockScrapService,
    private alertService: AlertService,
  ) {}

  ngOnInit(): void {
    this.productService.getProductPicker().subscribe({
      next: (products) => (this.products = products),
      error: () => (this.products = []),
    });
  }

  onProductSearchInput(): void {
    this.selectedProduct = null;
  }

  selectProduct(product: ProductPickerItem): void {
    this.selectedProduct = product;
    this.productSearchTerm = product.productName;
  }

  get availableStock(): number | null {
    if (!this.selectedProduct) return null;
    return this.warehouse === 'Markstey' ? this.selectedProduct.mStockQty : this.selectedProduct.kStockQty;
  }

  get overStock(): boolean {
    return this.availableStock !== null && !!this.quantity && this.quantity > this.availableStock;
  }

  onSubmit() {
    if (!this.selectedProduct?.productVariantId) {
      this.alertService.alert('Select a product first', 'error');
      return;
    }
    if (!this.quantity || this.quantity <= 0) {
      this.alertService.alert('Enter a quantity greater than zero', 'error');
      return;
    }
    if (this.overStock) {
      this.alertService.alert(`Only ${this.availableStock} in stock at ${this.warehouse}`, 'error');
      return;
    }

    this.submitting = true;
    this.stockScrapService
      .createScrap({
        productVariantId: this.selectedProduct.productVariantId,
        quantity: this.quantity,
        warehouse: this.warehouse,
        reason: this.reason,
        notes: this.notes,
      })
      .subscribe({
        next: () => {
          this.alertService.alert('Scrap logged and stock updated', 'success');
          this.dialogRef.close({ status: true });
        },
        error: (error) => {
          this.submitting = false;
          this.alertService.alert(error?.error?.message || 'Failed to log scrap', 'error');
        },
      });
  }
}
